import { cn } from "@/lib/utils";
import { BaseIconProps } from "../Icon.model";

export default function LinkedinIcon({
  size = 24,
  fill,
  stroke,
  className,
  ...props
}: BaseIconProps) {
  return (
    <div className="group relative inline-block">
      {/* Default state - visible by default, hidden on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 49 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "transition-opacity duration-200 group-hover:opacity-0 group-focus:opacity-0",
          className,
        )}
        {...props}
      >
        <g clipPath="url(#clip0_14638_60)">
          <circle
            cx="26.2084"
            cy="23.1797"
            r="21.1484"
            stroke={stroke || "white"}
            strokeWidth="2"
            fill={fill || "none"}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.0303 15.4513C21.0387 16.8828 19.9702 17.7649 18.7023 17.7586C17.5078 17.7523 16.4665 16.7986 16.4728 15.4534C16.4791 14.1882 17.4763 13.1713 18.7715 13.2008C20.0857 13.2303 21.0387 14.1966 21.0303 15.4513ZM26.6417 19.5816H22.8798H22.8777V32.396H26.8537V32.097C26.8537 31.5283 26.8532 30.9595 26.8528 30.3904C26.8516 28.8727 26.8503 27.3534 26.858 25.8362C26.8601 25.4677 26.8768 25.0846 26.9713 24.733C27.326 23.4194 28.5038 22.571 29.818 22.7795C30.6618 22.912 31.2202 23.4026 31.4553 24.2005C31.6002 24.6993 31.6653 25.2361 31.6716 25.7562C31.6886 27.3245 31.6862 28.8928 31.6838 30.4612C31.6829 31.0148 31.682 31.5687 31.682 32.1223V32.3939H35.6707V32.0866C35.6707 31.4099 35.6704 30.7334 35.6699 30.0569C35.6692 28.366 35.6683 26.6751 35.6728 24.9836C35.6749 24.2194 35.593 23.4658 35.4061 22.7268C35.127 21.6279 34.5497 20.7184 33.6113 20.0617C32.9458 19.5943 32.2153 19.2932 31.3987 19.2595C31.3057 19.2557 31.212 19.2506 31.1178 19.2455C30.7002 19.2229 30.2758 19.1999 29.8766 19.2806C28.7346 19.5101 27.7313 20.0343 26.9734 20.9584C26.8853 21.0644 26.7992 21.172 26.6707 21.3326L26.6417 21.369V19.5816ZM16.7921 32.4002H20.7492V19.59H16.7921V32.4002Z"
            fill={fill || "white"}
          />
        </g>
        <defs>
          <clipPath id="clip0_14638_60">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(0.872803)"
            />
          </clipPath>
        </defs>
      </svg>

      {/* Hover state - hidden by default, visible on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "absolute top-0 left-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus:opacity-100",
          className,
        )}
        {...props}
      >
        <circle
          cx="21.1133"
          cy="19.3164"
          r="17.457"
          fill="white"
          stroke="white"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7979 12.8759C16.8049 14.0688 15.9145 14.8039 14.8579 14.7987C13.8625 14.7934 12.9948 13.9987 13 12.8777C13.0053 11.8233 13.8362 10.976 14.9156 11.0005C16.0107 11.0251 16.8049 11.8303 16.7979 12.8759ZM21.4741 16.3179H18.3392H18.3375V26.9965H21.6507V26.7474C21.6507 26.2734 21.6504 25.7994 21.65 25.3252C21.649 24.0605 21.6479 22.7943 21.6544 21.53C21.6561 21.223 21.67 20.9037 21.7488 20.6107C22.0443 19.516 23.0259 18.809 24.121 18.9828C24.8242 19.0932 25.2895 19.502 25.4854 20.1669C25.6062 20.5826 25.6604 21.03 25.6657 21.4634C25.6798 22.7703 25.6778 24.0772 25.6759 25.3842C25.6751 25.8455 25.6744 26.3071 25.6744 26.7685V26.9948H28.9982V26.7386C28.9982 26.1748 28.998 25.611 28.9976 25.0472C28.997 23.6382 28.9962 22.2291 29 20.8195C29.0017 20.1826 28.9335 19.5546 28.7778 18.9389C28.5452 18.023 28.0641 17.2652 27.2821 16.7179C26.7275 16.3284 26.1187 16.0775 25.4382 16.0495C25.3607 16.0462 25.2826 16.042 25.2041 16.0377C24.8562 16.0189 24.5025 15.9997 24.1699 16.067C23.2182 16.2582 22.3821 16.6951 21.7505 17.4652C21.6771 17.5535 21.6053 17.6432 21.4982 17.777L21.4741 17.8074V16.3179ZM13.2661 27H16.5636V16.3248H13.2661V27Z"
          fill="black"
        />
      </svg>
    </div>
  );
}
